export const defaultTheme = {
  colors: {
    background: "#1F2029",
    grey900: "#181B23",
    yellow: "#FFEA3E",
    grey700: "#353646",
    blue: "#26AEE7",

    primary: "#FF8700",
    primaryDark: "#FF7A00",
    secondary: "#FF500F",
    greyLowerOpacity: "#abaebf",
    lightGrey: "#F5F6FA",
    error: "#FD4F48",
    label: "#fff",
  },

  "900": "#181B23",
  "800": "#1F2029",
  fontSizes: {
    default: "1.4rem",
    large: "1.7rem",
    small: "1.2rem",
    tiny: "1rem",
  },
  spacing: {
    default: "1.6rem",
    vertical: "1.6rem 0",
    horizontal: "0 1.6rem",
    large: "2.4rem",
  },
  transition: {
    default: "180ms ease-in-out",
  },
  radii: {
    default: "0.8rem",
    small: "0.4rem",
    smallTop: "0.4rem 0.4rem 0 0",
    smallBottom: "0 0 0.4rem 0.4rem",
    tiny: "0.2rem",
  },
  shadows: {
    default: "0 0.5rem 2rem rgba(0, 0, 0, 0.08)",
    flat: "0 0.2rem 0.2rem rgba(0, 0, 0, 0.08)",
  },
};
